import { render, staticRenderFns } from "./TableRiskAnalysis.vue?vue&type=template&id=117e2a95"
import script from "./TableRiskAnalysis.vue?vue&type=script&lang=js"
export * from "./TableRiskAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports